const baseUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/public-fundraisers`;

type FundraiserResponse<T> = {
  data: T;
  degraded?: boolean;
  detail?: string;
};

async function requestFundraisers<T>(search: URLSearchParams, fallback: T): Promise<FundraiserResponse<T>> {
  try {
    const res = await fetch(`${baseUrl}?${search.toString()}`, {
      headers: { apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY },
    });

    const text = await res.text();
    const json = text ? JSON.parse(text) : {};

    if (!res.ok) {
      return {
        data: fallback,
        degraded: true,
        detail: json?.detail ?? json?.error ?? `HTTP ${res.status}`,
      };
    }

    return {
      data: (json?.data ?? fallback) as T,
      degraded: Boolean(json?.degraded),
      detail: json?.detail,
    };
  } catch (error) {
    return {
      data: fallback,
      degraded: true,
      detail: error instanceof Error ? error.message : "Request failed",
    };
  }
}

export async function fetchFundraisersList() {
  return requestFundraisers<any[]>(new URLSearchParams({ mode: "list" }), []);
}

export async function fetchFeaturedFundraisers(limit = 3) {
  return requestFundraisers<any[]>(
    new URLSearchParams({ mode: "featured", limit: String(limit) }),
    [],
  );
}

export async function fetchFundraiserBySlug(slug: string) {
  return requestFundraisers<any | null>(
    new URLSearchParams({ mode: "by_slug", slug }),
    null,
  );
}